module.exports = __webpack_public_path__ + "static/media/refresh.8bf7c5d3.svg";